import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Decor_feed.png'
import _imports_1 from '../assets/img/Bg_tour.png'


const _withScopeId = n => (_pushScopeId("data-v-0abc377c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view tour" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tour__decor",
  src: _imports_0
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "slider__image slider__image-1",
  src: _imports_1
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode(" Приветствуем "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" в Burngram! ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Создавайте арты, которые автоматически регистрируются в блокчейне и распространяйте их в своих социальных сетях. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Работа, набравшая наибольшее количество лайков или шерингов - выкупается. За каждую активность (приглашение друзей, активный шеринг, заполнение информации) - начисляются берны и открываются ачивки. ")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "slider__image slider__image-2",
  src: _imports_1
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Как это работает?", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Создай свой уникальный нейро-арт, который автоматически зарегистрируется в блокчейне. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Привлекай своих друзей, оценивай других, собирай ачивки и зарабатывай на этом. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 1 burn = 1 генерация ")
], -1))

import { TourService } from '@/services/TourService';
import BaseSlider from '@/components/shared/BaseSlider.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TourView',
  setup(__props) {

function onFinish() {
	TourService.changeStep(1);
	window.location.reload();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(BaseSlider, {
      onFinish: onFinish,
      slides: 2,
      "use-toggle": true,
      "use-next-button": true
    }, {
      "1": _withCtx(() => [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5
      ]),
      "2": _withCtx(() => [
        _hoisted_6,
        _hoisted_7,
        _hoisted_8
      ]),
      _: 1
    })
  ]))
}
}

})